module.exports = __webpack_public_path__ + "static/media/chicken_stamp_fr.ebb8f32c.svg";